<template>
  <div class="dispatch">
    <div class="both" @click="show = true">
      <div>整改期限</div>
      <div>{{ time }}</div>
    </div>
    <div class="both" @click="branchShow = true">
      <div>责任部门</div>
      <div>
        {{ branch }}
        <div class="line-right">
          <img
            v-if="!branch"
            src="../../assets/images/mine/jiantou.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="both">
      <div class="title">整改建议</div>
      <div>
        <textarea placeholder="请简单描述..." v-model="suggestion"></textarea>
      </div>
    </div>
    <van-popup v-model="show" position="bottom" :style="{ height: '30%' }">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="settime"
      />
    </van-popup>
    <van-popup
      v-model="branchShow"
      position="bottom"
      :style="{ height: '30%' }"
    >
      <div class="area-container">
        <div class="btn-wrap">
          <div class="cancel-btn btn" @click="closeDialog">取消</div>
          <div class="confirm-btn btn" @click="closeDialog">确定</div>
        </div>
        <div class="area-list">
          <div
            :class="selectedIndexes.includes(i) ? 'active' : ''"
            v-for="(item, i) in departList"
            :key="i"
            @click="selectArea(item, i)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </van-popup>
    <div class="send-btn" @click="sendOrder">立即派单</div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { postEvent, getAreaList, getCateList, getDepartmentList } from "./api";
export default {
  data() {
    return {
      // 支持多选
      selectedIndexes: [],
      selectedIds: [],
      queryData: {},
      img: [],
      content: "",
      time: this.filterTime(new Date()),
      branch: "",
      branch_id: "",
      show: false,
      branchShow: false,
      minDate: new Date(),
      maxDate: new Date(2030, 10, 1),
      currentDate: new Date(),
      areaList: [],
      suggestion: "",
    };
  },
  computed: {
    ...mapGetters({
      cateGet: "cate/get",
    }),
    pointData() {
      return this.cateGet("point");
    },
    form() {
      return this.cateGet("form");
    },
    cateContent() {
      return this.cateGet("cateContent");
    },
    departList() {
      return this.cateGet("departList");
    },
  },
  watch: {
    cateContent(v) {
      this.title = v;
    },
    form(v) {
      this.cate = v.cate;
      this.address = v.address;
      this.imgList = v.img;
      this.content = v.content;

      this.time = v.timelimit;
      this.branch_id = v.area_id;
      // 如果已有 area_id（可能是逗号分隔），恢复已选状态
      if (v.area_id) {
        this.selectedIds = String(v.area_id).split(",");
        // 通过 departList 恢复显示名称（若 departList 已加载）
        this.updateBranchFromIds();
      }
    },
    departList(newVal) {
      // departList 加载后，如果有已存的 selectedIds，恢复选中索引
      if (
        this.selectedIds &&
        this.selectedIds.length &&
        newVal &&
        newVal.length
      ) {
        this.selectedIndexes = [];
        this.selectedIds.forEach((id) => {
          const idx = newVal.findIndex((d) => String(d.id) === String(id));
          if (idx > -1) this.selectedIndexes.push(idx);
        });
      }
    },
  },
  created() {
    // console.log("路由", this.$route.query);
    // this.queryData = this.$route.query;
    // this.getDepartmentList();
  },
  methods: {
    ...mapActions({
      clear: "cate/clear",
      setOrder: "cate/setOrder",
    }),
    filterTime(time) {
      var date = new Date(time);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      // return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + s
      return y + "-" + m + "-" + d;
    },
    settime(val) {
      this.show = false;
      this.time = this.getTime(val);
      // console.log("选中的时间", this.time);
    },
    getTime(data) {
      let month = Number(data.getMonth()) + 1;
      let day = data.getDate();
      return (
        data.getFullYear().toString() +
        "-" +
        (month > 9 ? month : "0" + month) +
        "-" +
        (day > 9 ? day : "0" + day)
      );
    },
    // 部门列表
    getDepartmentList() {
      let params = {
        id: this.queryData.point_id,
      };
      getDepartmentList(params).then((res) => {
        this.areaList = res.data.department;
      });
    },
    // 选择部门
    selectArea(item, i) {
      const idxPos = this.selectedIndexes.indexOf(i);
      if (idxPos > -1) {
        // 已选 -> 取消选中
        this.selectedIndexes.splice(idxPos, 1);
        const idPos = this.selectedIds.indexOf(String(item.id));
        if (idPos > -1) this.selectedIds.splice(idPos, 1);
      } else {
        // 选中
        this.selectedIndexes.push(i);
        this.selectedIds.push(String(item.id));
      }
      // 更新展示名称与派单使用的 area_id（逗号分隔）
      this.updateBranchFromIds();
    },
    updateBranchFromIds() {
      if (!this.selectedIds || this.selectedIds.length === 0) {
        this.branch = "";
        this.branch_id = "";
        return;
      }
      this.branch_id = this.selectedIds.join(",");
      // 将 id 转为 name（如果 departList 可用）
      if (this.departList && this.departList.length) {
        const names = [];
        this.selectedIds.forEach((id) => {
          const found = this.departList.find(
            (d) => String(d.id) === String(id)
          );
          if (found) names.push(found.name);
        });
        this.branch = names.join(",") || this.selectedIds.join(",");
      } else {
        this.branch = this.selectedIds.join(",");
      }
    },
    closeDialog() {
      this.branchShow = false;
    },
    // 派单
    async sendOrder() {
      if (!this.time) {
        this.$toast.fail("请选择整改期限时间");
      } else if (!this.branch) {
        this.$toast.fail("请选择责任部门");
      } else {
        this.$toast.loading({ duration: 0, message: "派单中" });
        // let params = {
        //   cate: this.queryData.cate,
        //   address: this.queryData.address,
        //   img: this.queryData.img,
        //   content: this.queryData.content,
        //   timelimit: this.time,
        //   area_id: this.branch_id,
        //   is_archive: 0,
        //   token: window.localStorage.getItem("token"),
        // };
        this.setOrder({
          timelimit: this.time,
          area_id: this.branch_id,
        });
        const params = this.form;
        params.is_archive = 0;
        params.token = window.localStorage.getItem("token");
        params.suggestion = this.suggestion;
        // console.log('参数', params)
        postEvent(params).then((res) => {
          console.log("res", res);
          if (res.code == 0) {
            this.$toast.clear();
            this.$toast.success("派单成功!");
            this.clear();
            setTimeout(() => {
              this.$router.replace("/");
            }, 1200);
          } else {
            this.$toast.fail(res.message);
          }
        });
      }
    },
  },
};
</script>
<style scoped lang="less">
.dispatch {
  padding: 15px;
  .both {
    height: 42px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .line-right {
      img {
        width: 6.6px;
        height: 12px;
      }
    }
  }
  > div:first-child,
  > div:nth-child(2) {
    border-bottom: 1px solid #d7d7d7;
  }
  > div:nth-child(3) {
    flex-direction: column;
    align-items: flex-start;
    .title {
      margin: 10px 0;
    }
    textarea {
      width: 360px;
      height: 2.8rem;
      border: 0.02rem solid rgba(225, 225, 225, 1);
      border-radius: 6px;
      padding: 10px;
      background: rgba(244, 246, 248, 1);
      resize: none;
    }
    textarea::-webkit-input-placeholder {
      color: #969799;
    }
  }
  ::v-deep .van-popup {
    overflow: hidden;
  }
  .area-container {
    .btn-wrap {
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .btn {
        // width: 30px;
        height: 20px;
        font-size: 15px;
      }
      .cancel-btn {
        color: #999999;
        margin-left: 30px;
      }
      .confirm-btn {
        color: #206aff;
        margin-right: 30px;
      }
    }
    .area-list {
      height: 200px;
      overflow-y: auto;
      margin-top: 5px;
      margin-left: 30px;
      margin-right: 30px;
      padding-bottom: 35px;
      display: flex;
      // justify-content: space-around;
      flex-wrap: wrap;
      div {
        margin-right: 15px;
        height: 34px;
        padding: 0 15px;
        line-height: 34px;
        font-size: 12px;
        color: #999999;
        background: rgba(238, 242, 241, 1);
        text-align: center;
        margin-bottom: 10px;
        border-radius: 2px;
      }
      .active {
        color: #ffffff;
        background: #206aff;
      }
    }
  }
  .send-btn {
    position: fixed;
    left: 18px;
    right: 18px;
    bottom: 32px;
    height: 50px;
    color: #fff;
    font-size: 16px;
    line-height: 50px;
    background-color: #206aff;
    text-align: center;
    cursor: pointer;
    margin-top: 20px;
    margin-bottom: 20px;
    border-radius: 0.14rem;
  }
}
</style>
